import { ChangeStepTrigger } from 'js/actionCreators/aiFeaturesActions';
import {
  ImageDrawerTab,
  VSLibraryImage,
  GeneralSearchImage,
  PremiumSearchImage,
  ImageSource,
  FacetsList,
  ImageSourcePagination,
  ImageLibraryCategoryPagination
} from 'js/types';

export const CHANGE_IMAGE_DRAWER_TAB = 'CHANGE_IMAGE_DRAWER_TAB';
export const SHOW_IMAGE_GENERATION_VIEW = 'SHOW_IMAGE_GENERATION_VIEW';
export const GET_CATEGORY_IMAGES = 'GET_CATEGORY_IMAGES';
export const GET_CATEGORY_IMAGES_SUCCESS = 'GET_CATEGORY_IMAGES_SUCCESS';
export const GET_CATEGORY_IMAGES_FAILURE = 'GET_CATEGORY_IMAGES_FAILURE';
export const GET_SEARCH_IMAGES = 'GET_SEARCH_IMAGES';
export const GET_SEARCH_IMAGES_SUCCESS = 'GET_SEARCH_IMAGES_SUCCESS';
export const GET_SEARCH_IMAGES_FAILURE = 'GET_SEARCH_IMAGES_FAILURE';
export const UPDATE_SEARCH_TAB_VIEWED = 'UPDATE_SEARCH_TAB_VIEWED';

export interface ChangeImageDrawerTabAction {
  type: typeof CHANGE_IMAGE_DRAWER_TAB;
  tab: ImageDrawerTab;
}

export const changeImageDrawerTab = (tab: ImageDrawerTab): ChangeImageDrawerTabAction => ({
  type: CHANGE_IMAGE_DRAWER_TAB,
  tab
});

export interface ShowImageGenerationViewAction {
  type: typeof SHOW_IMAGE_GENERATION_VIEW;
  trigger: ChangeStepTrigger;
  prompt?: string;
}

export const showImageGenerationView = (
  trigger: ChangeStepTrigger,
  prompt?: string
): ShowImageGenerationViewAction => ({
  type: SHOW_IMAGE_GENERATION_VIEW,
  trigger,
  prompt
});

export interface GetCategoryImagesAction {
  type: typeof GET_CATEGORY_IMAGES;
  categoryId: string;
  imageSource: ImageSource;
  nextPageId: string;
  pagination?: Array<ImageLibraryCategoryPagination>;
}

export const getCategoryImages = (
  categoryId: string,
  imageSource: ImageSource,
  nextPageId: string,
  pagination?: Array<ImageLibraryCategoryPagination>
): GetCategoryImagesAction => ({
  type: GET_CATEGORY_IMAGES,
  categoryId,
  imageSource,
  nextPageId,
  pagination
});

export interface GetCategoryImagesSuccessAction {
  type: typeof GET_CATEGORY_IMAGES_SUCCESS;
  categoryId: string;
  imageSource: ImageSource;
  images: Array<VSLibraryImage>;
  nextPageId: string | null;
  pagination?: Array<ImageLibraryCategoryPagination>;
}

export const getCategoryImagesSuccess = (
  categoryId: string,
  imageSource: ImageSource,
  images: Array<VSLibraryImage>,
  nextPageId: string | null,
  pagination?: Array<ImageLibraryCategoryPagination>
): GetCategoryImagesSuccessAction => ({
  type: GET_CATEGORY_IMAGES_SUCCESS,
  categoryId,
  imageSource,
  images,
  nextPageId,
  pagination
});

export interface GetCategoryImagesFailureAction {
  type: typeof GET_CATEGORY_IMAGES_FAILURE;
  categoryId: string;
  imageSource: ImageSource;
}

export const getCategoryImagesFailure = (
  categoryId: string,
  imageSource: ImageSource
): GetCategoryImagesFailureAction => ({
  type: GET_CATEGORY_IMAGES_FAILURE,
  categoryId,
  imageSource
});

export interface GetSearchImagesAction {
  type: typeof GET_SEARCH_IMAGES;
  imageSource: ImageSource;
  searchInput: string;
  offset: number;
  nextPageId?: string;
  isPrefetch?: boolean;
  pagination?: Array<ImageSourcePagination>;
}

export const getSearchImages = (
  imageSource: ImageSource,
  searchInput: string,
  offset: number,
  nextPageId?: string,
  isPrefetch = false,
  pagination?: Array<ImageSourcePagination>
): GetSearchImagesAction => ({
  type: GET_SEARCH_IMAGES,
  imageSource,
  searchInput,
  offset,
  nextPageId,
  isPrefetch,
  pagination
});

export interface GetSearchImagesSuccessAction {
  type: typeof GET_SEARCH_IMAGES_SUCCESS;
  imageSource: ImageSource;
  images: Array<GeneralSearchImage> | Array<PremiumSearchImage>;
  offset: number;
  total: number;
  searchInput: string;
  nextPageId?: string;
  isPrefetch: boolean;
  facets?: FacetsList;
  pagination?: Array<ImageSourcePagination>;
}

interface GetSearchImagesSuccessActionInputs {
  imageSource: ImageSource;
  images: Array<GeneralSearchImage> | Array<PremiumSearchImage>;
  offset: number;
  total: number;
  searchInput: string;
  isPrefetch: boolean;
  nextPageId?: string;
  facets?: FacetsList;
  pagination?: Array<ImageSourcePagination>;
}

export const getSearchImagesSuccess = ({
  imageSource,
  images,
  offset,
  total,
  searchInput,
  nextPageId,
  isPrefetch,
  facets,
  pagination
}: GetSearchImagesSuccessActionInputs): GetSearchImagesSuccessAction => ({
  type: GET_SEARCH_IMAGES_SUCCESS,
  imageSource,
  images,
  offset,
  total,
  searchInput,
  nextPageId,
  isPrefetch,
  facets,
  pagination
});

export interface GetSearchImagesFailureAction {
  type: typeof GET_SEARCH_IMAGES_FAILURE;
  imageSource: ImageSource;
  searchInput: string;
}

export const getSearchImagesFailure = (
  imageSource: ImageSource,
  searchInput: string
): GetSearchImagesFailureAction => ({
  type: GET_SEARCH_IMAGES_FAILURE,
  imageSource,
  searchInput
});

export interface UpdateSearchTabViewedAction {
  type: typeof UPDATE_SEARCH_TAB_VIEWED;
  imageSource: ImageSource;
  searchInput: string;
  isViewed?: boolean;
}

export const updateSearchTabViewed = (
  imageSource: ImageSource,
  searchInput: string,
  isViewed = true
): UpdateSearchTabViewedAction => ({
  type: UPDATE_SEARCH_TAB_VIEWED,
  imageSource,
  searchInput,
  isViewed
});
